// Abhinashdeep Singh 8907518
import React from "react";
import "../styles/Contact.css";
import ContactHeader from "../components/ContactHeader";
import ContactDetails from "../components/ContactDetails";

const Contact = () => {
    return (
        <div>
            <ContactHeader />
            <ContactDetails />
        </div>
    );
};

export default Contact;
